import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { AuthContext } from './AuthContext';

export const OrderContext = createContext();
const API_BASE = '/api';

export const OrderProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const { user } = useContext(AuthContext);

  const loadOrders = useCallback(async (token) => {
    try {
      const res = await fetch(`${API_BASE}/orders`, {
        headers: {
          'x-auth-token': token,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.msg || 'Failed to fetch orders');
      }

      setOrders(Array.isArray(data.orders) ? data.orders : []);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      setOrders([]);
    }
  }, []);

  useEffect(() => {
    if (user && (user.role === 'admin' || user.role === 'superadmin')) {
      const token = localStorage.getItem('token');
      loadOrders(token);
    } else {
      setOrders([]);
    }
  }, [user, loadOrders]);

  const toggleOrderStatus = async (orderId) => {
    if (!user || (user.role !== 'admin' && user.role !== 'superadmin')) {
      console.error('You do not have permission to change order statuses.');
      return;
    }

    const order = orders.find((o) => o.id === orderId);
    if (!order) return;

    const newStatus = order.status === 'Completed' ? 'Pending' : 'Completed';
    const token = localStorage.getItem('token');

    try {
      const res = await fetch(`${API_BASE}/orders/${orderId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
        body: JSON.stringify({ status: newStatus }),
      });

      const updatedOrder = await res.json();

      if (!res.ok) {
        throw new Error(updatedOrder.msg || 'Failed to update order status');
      }

      setOrders((prevOrders) => prevOrders.map((o) => (o.id === orderId ? updatedOrder : o)));
    } catch (error) {
      console.error('Failed to update order status:', error);
    }
  };

  return (
    <OrderContext.Provider value={{ orders, toggleOrderStatus }}>
      {children}
    </OrderContext.Provider>
  );
};
